import { Modal } from "react-bootstrap";
import React, { useContext, useState, useEffect } from "react";
import "../../../../Admin/Tabels/Tabels.css";
import { Context } from "../../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import ModalSave from "../../../../common/ModalSave";
import { CancelButton } from "../../../../common/Button";
import AddedLottieModal from "../../../commonLottie/AddedLottieModal";

library.add(fas);

const EditModal = (props) => {
  const { postData, getData } = useContext(Context);
  const [showLottie, setShowLottie] = useState({ show: false, msg: "", success: false });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
    reset,
  } = useForm();

  useEffect(() => {
    const GetEditData = async () => {
      const response = await getData(`/hrms-masters/office-address/${props.show}`);
      reset(response?.data);
    };
    GetEditData()
  }, [props.show]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("address", data?.address);

      const response = await postData(`/hrms-masters/office-address/${props.show}`, sendData);
     

      if (response?.success) {
        setShowLottie({ show: true, msg: response?.message, success: response?.success });
      } else {
        setShowLottie({ show: true, msg: response?.message, success: response?.success });
      }
      setTimeout(() => {
        setShowLottie({ show: false, msg: "", success: false });
        props.handleClose()
      }, 3000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section className="modal-common-class-hrms">
      <Modal
        show={props.show}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="add-modal"
        onHide={props.handleClose}
      >
        <Modal.Body>
          <div className="text-center">
            <h4 className="modal-title-common">Edit Address</h4>
          </div>
          <Container>
            <Row>
              <Col md={12}>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col lg={12} md={15} className="mx-auto Add-content">
                      <div className="main-form-section mt-5">
                        <Form.Label>Address</Form.Label>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <InputGroup>
                            <Form.Control
                              as="textarea"
                              name="name"
                              placeholder="Address"
                              maxLength={3}
                              minLength={3}
                              className={classNames("", {
                                "is-invalid": errors?.address,
                              })}
                              {...register("address", {
                                required: "Address is required",
                              })}
                            />
                          </InputGroup>

                          {errors.address && (
                            <span className="text-danger">
                              {errors.address.message}
                            </span>
                          )}
                        </Form.Group>
                      </div>
                      <div className="d-flex justify-content-center mt-5 pb-3">
                        <CancelButton
                          name="cancel"
                          handleClose={props.handleClose}
                        />
                        <button type="submit" className="save-button">
                          Save
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
      <AddedLottieModal
        pageTitle="Designation"
        message={showLottie.msg}
        show={showLottie.show}
        success={showLottie.success}
        onHide={() => setShowLottie({ show: false, msg: "", success: false })}
      />
    </section>
  );
};

export default EditModal;
